module.exports = __webpack_public_path__ + "img/Vectorloading.65a115b5.svg";